// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.attached-files-list[data-v-4a1d4dc0] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-wrap: wrap;\n      flex-wrap: wrap;\n}\n.attached-files-list > .attached-file[data-v-4a1d4dc0]:not(:last-child) {\n  margin-right: 16px;\n}\n.attached-files-list > .attached-file[data-v-4a1d4dc0] {\n  margin-bottom: 16px;\n}\n\n", ""]);
// Exports
module.exports = exports;
